import { login as loginRequest } from '@/request';
import { createStoreUser } from '@/store';
import { getCookies, removeCookies, setCookies } from '@shareuc/share';
import axios from 'axios';
import { action, computed } from 'mobx';

const storeUser = createStoreUser();

export const userStoreUser = () => {
  const login = action(async (username: string, password: string) => {
    try {
      const res = await loginRequest(username, password);
      if (res) {
        const user = res.data.user.id;
        const username = res.data.user.username;
        const jwt = res.data.jwt;
        const email = res.data.user.email;
        storeUser.user = user;
        storeUser.username = username;
        storeUser.jwt = jwt;
        storeUser.email = email;
        setCookies('shareuc_user', user, {
          domain: import.meta.env.VITE_COOKIE_DOMAIN,
        });
        setCookies('shareuc_username', username, {
          domain: import.meta.env.VITE_COOKIE_DOMAIN,
        });
        setCookies('shareuc_email', email, {
          domain: import.meta.env.VITE_COOKIE_DOMAIN,
        });
        setCookies('shareuc_jwt', jwt, {
          domain: import.meta.env.VITE_COOKIE_DOMAIN,
        });
        return true;
      }
    } catch {
      return false;
    }
  });

  const logout = action(() => {
    storeUser.user = '';
    storeUser.username = '';
    storeUser.jwt = '';
    removeCookies('shareuc_user');
    removeCookies('shareuc_username');
    removeCookies('shareuc_jwt');
    removeCookies('shareuc_email');
  });

  const isLogin = computed(() => {
    return !!storeUser.jwt;
  });

  const checkJwt = action(async () => {
    const jwt = getCookies('shareuc_jwt');
    if (jwt) {
      try {
        await axios.get(`${import.meta.env.VITE_API_URL}/users/me`, {
          headers: {
            Authorization: 'Bearer ' + jwt,
          },
        });
      } catch {
        logout();
      }
    }
  });

  return {
    store: storeUser,
    login,
    logout,
    isLogin,
    checkJwt,
  };
};
